<template>
 <page>

   <head-nav title="language.add_documents_item">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>
    <page-padding>
      <ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>

      <button-action v-if="isMobile" v-on:click.native="choosePDF()" title="language.choose_pdf" ></button-action>
      
      <!-- desktop variant -->
      <button-file v-if="!isMobile" :multiple="false" accept="application/pdf" title="language.choose_pdf" @change="choosePDF"></button-file>

      <div class="file-graphic" v-if="file">
        <div class="file-icon"><font-awesome-icon   v-bind='{ icon:"file" }' /></div>
        <div>{{file.name}}</div>
      </div>

      <divider title=""/>
      

      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
     
     </page-padding>
</scroll-page>  
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import ButtonFile from '../components/buttons/ButtonFile.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiTextarea from '../components/UiTextarea.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import Vue from 'vue';
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';
import { fileTransfer } from '../services/FileTransfer.js';
import { api } from '../services/Api';
import { cordovaInit } from '../services/CordovaInit.js';

export default {
  name: 'add-document-item-page',
  data:function(){
    return{
      id:this.$route.params.id,
      description:"",
      buttonActive:true,
      file:undefined,
      isMobile:cordovaInit.isMobile(),
    }
  },
  computed:{
     ...mapState([
       'user_schools','appSettings'
       ]),
       computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.add_documents_item');
        }
      },
      upload_path:function(){
        var school=this.user_schools.find(school => school.active === 1);
        return api.getUrl(school,"add_pdf.php");
      },
  },
  components: {
    ButtonActivate,
    ButtonFile,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiTextarea,
    Page,
    ScrollPage,
    ButtonAction,
    Divider,
  },
  methods:{
    choosePDF(e){
     
        // create file for upload
        var reader = new FileReader();
        var fileName=e.target.files[0].name;
       
        reader.onload = (e)=>{
         var arrayBuffer = e.target.result;
        // create similar file as window.chooser.getFile('application/pdf') below
          this.file={
            data:new Uint8Array(arrayBuffer), // aka the blob type of file
            name:fileName,
          }
        }
        reader.readAsArrayBuffer(e.target.files[0]);
        
    },
    back(){
      this.$router.push(history.get());
    },
    isFormComplete(){
      
      if(this.file===undefined){
          modalService.createAlert(i18n.t('language.form_incomplete_file'))

        return false;
      }

      return true
    },
    
    clearForm(){
      this.file=undefined;
      this.description="";

      // we done here lets go back
      this.back();
    }, 
   
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

     this.buttonActive=false;
     setTimeout(()=>{
       this.callApi();
      },500);

    },
    callApi(){

      var loader=modalService.createLoader(i18n.t("language.uploading_file"))

       var params={
        token:this.appSettings.token,
        id:this.id,
        description:this.description,
        file_name:this.file.name,
      }


      //file uint8Array( this.file,data) to blob
      var blob = new Blob([this.file.data], {type:'application/pdf'});
      
      //console.dir(params)

      // upload blob, overzetten naar add_pdf
    setTimeout(()=>{

        fileTransfer.httpRequest(this.upload_path,blob,params).then(()=>{
          
          // TODO: resultaat nog bekijken ivm dubbele file upload...
          
          this.buttonActive=true;
          
          loader.close();
          this.clearForm();

          Vue.$toaster.toast("language.upload_file_complete");

        },(error)=>{
          Vue.$toaster.toast("language.upload_file_error"+error);
          this.buttonActive=true;
          loader.close();
        })

    },1000)
      

    },
    
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-graphic{
  margin-top:10px;
  display:inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.file-icon{
  font-size:2.5em;
}
</style>
